import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { commercialConstants } from '../../../../../common/commercial-constants';
import { ClaimsDataService } from '../../../services/claims-data.service';

import { FormatPolicyNumberService } from 'app/commercial/claims/services/format-policy-number.service';
import { LoggerService } from 'app/shared/services/logger.service';
import { PolicyInfoService } from 'app/commercial/claims/services/policy-info.service';
import { environment } from '../../../../../../environments/environment';
import { CommercialLoggingService } from '../../../services/commercial-logging.service';
import { IconSvgService } from '../../../services/icon-svg.service';
@Component({
    selector: 'is-policy-section',
    templateUrl: './policy-section.component.html',
    styleUrls: ['./policy-section.component.scss'],
    standalone: false
})
export class PolicySectionComponent implements OnInit {
    @Input() accountNumber = '';
    @Input() allClaimsList: any;
    @Input() lossCauseList: string[];
    @Input() policy: any;
    account: string;
    claimsList: any[] = [];
    hasClaims = false;
    isAuto: boolean;
    isLoaded: boolean;
    namedInsured: string;
    policyNumber: string;
    policyType: string;

    constructor(
        private router: Router,
        public claimsDataService: ClaimsDataService,
        private iconSvgService: IconSvgService,
        private LOGGER: LoggerService,
        public policyInfoService: PolicyInfoService,
        private formatPolicyNumberService: FormatPolicyNumberService,
        private commercialLoggingService: CommercialLoggingService
    ) {}

    getLossCause(lossCause: string): string {
        return this.claimsDataService.getLossCause(lossCause);
    }

    ctmLogConfirmationEvent(): void {
        this.commercialLoggingService.logButtonAction(
            this.LOGGER,
            'Package (PAK) Claims',
            'start-claim',
            'success',
            this.getLogMetadata()
        );
    }
    fileAClaim(): void {
        this.claimsDataService.setClaimsPolicyNumber(this.policyNumber);
        this.claimsDataService.setClaimsPolicyType(this.policyInfoService.getDisplayName(this.policy));
        this.claimsDataService.setFnolFlow(this.policy);
        this.ctmLogConfirmationEvent();
        this.commercialLoggingService.updatePreviousUrlContext();
        this.router.navigate([commercialConstants.URLS.firstNoticeOfLoss]);
    }

    fileAGlassClaim(): void {
        this.claimsDataService.setClaimsPolicyNumber(this.policyNumber);
        this.claimsDataService.setClaimsPolicyType(this.policyInfoService.getDisplayName(this.policy));
        this.claimsDataService.setFnolFlow(this.policy);
        this.commercialLoggingService.logButtonAction(
            this.LOGGER,
            'Package (PAK) Claims',
            'start-glass-claim',
            'success',
            this.getLogMetadata()
        );
        this.commercialLoggingService.updatePreviousUrlContext();
        window.open(environment.NATIONWIDE.GLASS_CLAIM, '_blank');
    }
    getFormattedPolicyNumber(): string {
        const claimPackage = this.claimsDataService.getClaimsPackage();
        const prefixA = this.formatPolicyNumberService.getFormattedPrefix(claimPackage.policyAccount.prefixA);
        const prefixB = this.formatPolicyNumberService.getFormattedPrefix(this.policy?.prefixB);
        return prefixA + prefixB + claimPackage.policyAccount.branchNumber +
            claimPackage.policyAccount.decNumber + claimPackage.policyAccount.policyNumber;
    }
    navigateToClaimOverview(claimNumber: string, premisisID: any): void {
        this.claimsDataService.setClaimNumber(claimNumber);
        this.claimsDataService.setFnolFlow(this.policy);
        this.claimsDataService.setClaimsPolicyNumber(this.policyNumber);
        this.claimsDataService.setClaimsPolicyType(this.policyInfoService.getDisplayName(this.policy));
        this.claimsDataService.setPremisisID(premisisID);
        this.commercialLoggingService.logButtonAction(
            this.LOGGER,
            'Package (PAK) Claims',
            'navigate-claim-overview',
            'success',
            this.getLogMetadata({ claimNumber })
        );
        this.commercialLoggingService.updatePreviousUrlContext();
        this.router.navigate([commercialConstants.URLS.claimOverview]);
    }
    navigateToPolicyClaimsList(): void {
        this.claimsDataService.setClaimsPolicyNumber(this.policyNumber);
        this.claimsDataService.setClaimsPolicyType(this.policyInfoService.getDisplayName(this.policy));
        this.claimsDataService.setFnolFlow(this.policy);
        this.commercialLoggingService.logButtonAction(
            this.LOGGER,
            'Package (PAK) Claims',
            'navigate-policy-claims-list',
            'success',
            this.getLogMetadata()
        );
        this.commercialLoggingService.updatePreviousUrlContext();
        this.router.navigate([commercialConstants.URLS.policyClaimsList]);
    }

    ngOnInit(): void {
        this.policyNumber = this.getFormattedPolicyNumber();
        this.isAuto = this.policyInfoService.getDisplayName(this.policy) === 'Business Auto';
        this.namedInsured = this.claimsDataService.getClaimsPackage() ?
            this.claimsDataService.getClaimsPackage().policyAccount.namedInsuredName : '';
        this.policyType = this.claimsDataService.getClaimsPolicyType();
        this.iconSvgService.init();
        this.retrieveClaimsList();
    }

    retrieveClaimsList(): void {
        const numberOfClaims = this.allClaimsList.claimSummaries?.length;
        if (numberOfClaims > 0) {
            for (const claimSummary of this.allClaimsList.claimSummaries) {
                if (this.formatPolicyNumberService.policyNumbersMatch(claimSummary.policyNumber, this.policyNumber)) {
                    this.claimsList.push(claimSummary);
                }
            }
        }
    }

    private getLogMetadata(additionalFields: any = {}): any {
        return {
            policyNumber: this.claimsDataService.getClaimsPolicyNumber(),
            policyType: this.claimsDataService.getClaimsPolicyType(),
            lineOfBusiness: this.claimsDataService.getFnolFlow(),
            claimsDisplayCount: this.claimsList.length || '0',
            alphaState: this.claimsDataService.getPrimary(this.claimsDataService.getClaimsPackage()?.address)?.state || 'UNKNOWN',
            previousUrl: window.sessionStorage.getItem('previousUrl') || '',
            ...additionalFields
        };
    }
}
